// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__2gIlK","image":"NotFound_image__295h5","text":"NotFound_text__3Vtft","button":"NotFound_button__2R4Bl"};